<template>
    <div class="mt-3" style="max-width: 800px;">
        <div class="tab-container-verification">
            <header class="d-flex justify-content-center pb-3">
                <ul class="nav nav-pills nav-fill">
                    <li class="nav-item">
                        <router-link :to="`${parentRoute}/verification`" class="nav-link"
                            :class="endsWith('verification')">Verification
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="`${parentRoute}/verification/companies-house`" class="nav-link"
                            :class="endsWith('companies-house')">Companies House
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="`${parentRoute}/verification/associated-tmln`" class="nav-link"
                            :class="endsWith('associated-tmln')"> Associated TMLN
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="`${parentRoute}/verification/activity-logs`" class="nav-link"
                            :class="endsWith('activity-logs')">Activity Logs
                        </router-link>
                    </li>
                </ul>
            </header>
        </div>
        <div class="mb-3 min-vw-100 bb"></div>
    </div>
</template>

<script>
export default {
    name: 'SchemeBusinessVerificationTabs',
    data() {
        return {
            env: import.meta.env.VITE_MODE,
        };
    },
    computed: {
        parentRoute() {
            let baseRoute = 'scheme-business';
            if (this.$route.meta.pendingLicences) {
                baseRoute = 'pending-licences';
            }
            return `/${baseRoute}/${this.$route.params.schemeId}/${this.$route.params.schemeBusinessId}`;
        },
        currentAccount() {
            return this.$store.state.auth.account;
        }
    },
    methods: {
        isVerification(str) {
            return this.$route.path.includes('verification') ? 'active' : '';
        },
        endsWith(str) {
            return this.$route.path.endsWith(str) ? 'active' : '';
        },
        isActiveTab(tab) {
            return this.$route.path.includes(tab) ? 'active' : '';
        }
    },
};
</script>

<style>
.tab-container-verification {
    box-sizing: border-box;
    font-weight: 500;
}

.bb {
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
}
</style>
